import Input from "components/input";
import { Label } from "components/label";
import Select from "components/select";
import { IAdditionalSetupForm, ISimpleEventDetail, PaymentMethodKey, SupportedCurrency, UserType } from "interfaces";
import { get } from "lodash";
import { Controller, useFormContext } from "react-hook-form";
import { ADMIN_USD_PAYMENT_METHODS, PAYMENT_METHODS, USD_PAYMENT_METHODS } from "utills/constants";
import { canAccessByType } from "utills/helpers";

export const PaymentMethod = ({ isEdit, eventDetailData }: { isEdit: boolean, eventDetailData: ISimpleEventDetail }) => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext<IAdditionalSetupForm>(); // retrieve all hook methods
  
  const currencyArr = eventDetailData.currency === SupportedCurrency.VND ? PAYMENT_METHODS : ADMIN_USD_PAYMENT_METHODS;
  
  return isEdit ? (
    <div className="box-container p-4 sm:p-6">
      <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6 lg:gap-x-6">
        <div className="sm:col-span-3">
          <Label required id="payment_method.ignore_payment_methods" name="Choose Payment Method" />
          <Controller
            control={control}
            name="payment_method.ignore_payment_methods"
            defaultValue={[]}
            render={({ field: { onChange, value = [], ref } }) => (
              <Select
                isMulti
                key={``}
                inputRef={ref}
                options={value.includes(PaymentMethodKey.ALL) ? [] : currencyArr}
                id="payment_method.ignore_payment_methods"
                placeholder="Choose payment method"
                value={value.map((id: string) => {
                  return currencyArr.find((item) => item.value === id);
                })}
                onChange={(selected: { label: string; value: string }[]) =>
                  selected.find(
                    (item) => item.value === PaymentMethodKey.ALL
                  )
                    ? onChange([PaymentMethodKey.ALL])
                    : onChange(selected.map((item) => `${item.value}`))
                }
                error={get(
                  errors,
                  `payment_method.ignore_payment_methods`,
                  ""
                )}
              />
            )}
          />

          {get(
            errors,
            `payment_method.ignore_payment_methods`,
            ""
          ) ? (
            <p className="error-text">
              <span className="font-medium">
                {get(
                  errors,
                  `payment_method.ignore_payment_methods.message`,
                  ""
                )}
              </span>
            </p>
          ) : null}
        </div>
        <div className="sm:col-span-3">
          <Label id="payment_method.payment_gateway_promotion_id" name="OnePay promotion id" />
          <Input
            id="payment_method.payment_gateway_promotion_id"
            type="text"
            placeholder="OnePay promotion id"
            error={get(errors, "payment_method.payment_gateway_promotion_id")}
            {...register("payment_method.payment_gateway_promotion_id")}
          />
          {get(
            errors,
            `payment_method.payment_gateway_promotion_id`,
            ""
          ) ? (
            <p className="error-text">
              <span className="font-medium">
                {get(
                  errors,
                  `payment_method.payment_gateway_promotion_id.message`,
                  ""
                )}
              </span>
            </p>
          ) : null}
        </div>

        {canAccessByType(UserType.ADMIN) &&
          <div className="sm:col-span-3">
            <Label
              id="payment_method.order_code_prefix"
              name="Order code prefix"
            />
            <Input
              id={`payment_method.order_code_prefix`}
              type="text"
              error={get(errors, `payment_method.order_code_prefix`, "")}
              placeholder="Order code prefix"
              {...register("payment_method.order_code_prefix")}
            />
            {get(errors, `payment_method.order_code_prefix`, "") ? (
              <p className="error-text">
                <span className="font-medium">
                  {get(
                    errors,
                    `payment_method.order_code_prefix.message`,
                    ""
                  )}
                </span>
              </p>
            ) : null}
          </div>
        }
      </div>
    </div>
  ) : <></>;
};
